// extracted by mini-css-extract-plugin
export default {"sidebar_wrapper":"sidebar_sidebar_wrapper__6Jfjg","res_visible_sidebar":"sidebar_res_visible_sidebar__Vy-wy"};